import { useState, useEffect } from "react";
import { checkIsMobile } from "../utils/isSafeToUseWindow";

/**
 * useIsMobile - Returns true when the viewport is at or below the mobile breakpoint (768px).
 * Reactively updates on window resize.
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(checkIsMobile);

  useEffect(() => {
    const handleResize = () => setIsMobile(checkIsMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

export default useIsMobile;
